<template>
  <el-dialog title="选择研发项目" :visible.sync="visible" width="60%" :before-close="befclose" :close-on-click-modal="false">
    <div>
      <el-input
        class="input search"
        prefix-icon="el-icon-search"
        size="small"
        v-model="projectListFrom.projectNameOrCode"
        @keyup.enter.native="screenChange"
        placeholder="搜索研发项目名称"
      />
      <!-- <el-row class="bm bm-ac selectList">
                <el-col class=" bm bm-f1 col">
                    <el-input v-model="projectListFrom.productName" placeholder="输入产品名称"></el-input>
                </el-col>
               <el-col class="bm bm-f1 col">
                    <el-input v-model="projectListFrom.productName" placeholder="输入产品名称"></el-input>
                    
                </el-col>
                <el-col class="bm bm-f1 col">
                    <el-select filterable v-model="projectListFrom.baseForm" @change="screenChange" placeholder="剂型" clearable size="mini">
                        <el-option v-for="(item,i) in screenFrom.baseFormList" :key="i" :label="item" :value="item"></el-option>                
                    </el-select>
                </el-col>
                <el-col class="bm bm-f1 col">
                    <el-select filterable v-model="projectListFrom.domainCode" @change="screenChange" placeholder="领域" clearable size="mini">
                        <el-option v-for="(item,i) in screenFrom.domainList" :key="i" :label="item" :value="item"></el-option>                        
                    </el-select>
                </el-col>
                <el-col class="bm bm-f1 col">
                    <el-select filterable v-model="projectListFrom.currentProgress" @change="screenChange" placeholder="当前进度" clearable size="mini">
                        <el-option v-for="(item,i) in screenFrom.currentProgressList" :key="i" :label="item" :value="item"></el-option>                 
                    </el-select>
                </el-col>
      </el-row>-->
      <el-radio-group v-model="info" v-loadmore="loadMore">
        <el-row
          :gutter="20"
          v-for="(data,index) in projectList"
          :key="index"
          class="background-row-choose"
        >
          <el-col :span="20">
            <el-radio :label="data">{{data.projectCode}} {{data.projectName}}</el-radio>
          </el-col>
        </el-row>
        <div class="load" v-if="loadShow">
          <div v-if="loadtxt == '暂无数据'" class="bm bm-ver bm-ac">
            <div class="not-devices">没有您要查找的项目</div>
          </div>
          <div v-else>{{loadtxt}}</div>
        </div>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" size="small">取消</el-button>
      <el-button type="primary" @click="handleConfirm" size="small">下一步</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { crmApi } from "@/services";
// const R = require("ramda");
import { researchApi } from "@/services";
import "@/utils/loadMore.js";
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    projectType: {
      type: String,
      required: true
    }
    /*        projectList: {
            type: Array,
            required: true
        } */
  },
  data() {
    return {
      keywords: "",
      info: {},

      screenFrom: {
        baseFormList: [],
        currentProgressList: [],
        domainList: [],
        projectStatusList: [],
        registerClassifyList: []
      }, //筛选
      projectList: [], //项目列表
      projectListFrom: {
        pageNo: 1,
        pageSize: 30,
        userCode: this.$store.state.init.initData.fillPersonCode,
        projectType: "researchAndDevelop",
        status: "",
        projectKeyword: "",
        managerName: "", //负责人
        departName: "", //项目部门
        productName: "",
        customerName: "",
        projectModeList: [],
        baseFormList: [],
        currentProgressList: [],
        researchTypeList: [],
        aidTypeList: [],
        secondaryTypeList: [],
        accessTypeList: [],
        sortColumn: "",
        sortDirection: ""
      },
      loadShow: false,
      loadtxt: "加载中...",
      pageTotals: 0
    };
  },
  watch: {},
  mounted() {
    this.getProjectList(); //项目列表
    console.log(this.$store.state.init.initData.fillPersonCode, "哈哈哈哈");
  },
  methods: {
    // 筛选改变
    screenChange() {
      // this.getProjectListScreen()
      this.projectListFrom.pageNo = 1;
      this.getProjectList();
    },
    handleSearch() {
      this.$emit("handleSearch", this.keywords);
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleConfirm() {
      this.$emit("handleConfirm", this.info);
    },
    befclose() {
      this.$emit("befclose");
    },
    getProjectList() {
      researchApi.getProjectList(this.projectListFrom).then(res => {
        console.log(res, "项目列表");

        if (res && res.msgCode == "100") {
          this.screenFrom = res.ext;
          let obj = res.responseData;
          this.projectList = res.responseData.list;
          if (this.projectListFrom.pageNo == 1) {
            this.projectList = [];
            this.projectListFrom.pageNo = 1;
            this.totalPages = 0;
          }
          if (obj.totalRecords == 0) {
            this.loadShow = true;
            this.loadtxt = "暂无数据";
          } else if (obj.totalPages == 1) {
            this.loadShow = false;
          } else {
            this.loadShow = true;
            this.loadtxt = "加载中...";
          }
          this.totalPages = obj.totalPages;
          this.projectList = this.projectList.concat(obj.list);
          this.loadSign = true;
          this.projectListFrom.pageNo++;
        }
      });
    },
    loadMore() {
      console.log("加载");
      if (this.loadSign) {
        this.loadSign = false;
        if (this.projectListFrom.pageNo > this.totalPages) {
          this.loadtxt = "没有数据了!";
          return;
        } else {
          setTimeout(() => {
            this.getProjectList();
          }, 1000);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/.el-dialog__header {
    padding: 21px 0px 18px 23px;
    border-bottom: 1px solid #dcdfe5;
  }
  /deep/.el-dialog__title {
    color: #323232;
  }
  /deep/.el-dialog__body {
    padding: 10px 20px;
    .search {
      margin-bottom: 10px;
      /deep/.el-input__inner {
        line-height: 33px;
      }
      .el-input__inner::-webkit-input-placeholder {
        font-size: 12px;
      }
    }
    .selectList {
      .col {
        margin-right: 10px;
      }
    }

    .el-radio-group {
      display: block;
      height: 300px;
      overflow: auto;
      width: 100%;
      .load {
        margin-top: 115px;
        font-size: 14px;
        text-align: center;
        padding: 10px 0;
      }
      .background-row-choose {
        width: 90%;
        background: #fff;
      }
      .el-row {
        padding: 10px 0;
        .el-radio__input.is-checked .el-radio__inner {
          border-color: #ed2e3d;
          background: #ed2e3d;
        }
        .el-radio__input.is-checked + .el-radio__label {
          color: #323232;
        }
        .el-radio__label {
          vertical-align: middle;
        }
        .el-radio__inner {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>
